import { render, staticRenderFns } from "./orderStatistics.vue?vue&type=template&id=b0d04680&scoped=true&"
import script from "./orderStatistics.vue?vue&type=script&lang=js&"
export * from "./orderStatistics.vue?vue&type=script&lang=js&"
import style0 from "./orderStatistics.vue?vue&type=style&index=0&id=b0d04680&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d04680",
  null
  
)

export default component.exports